module.exports = __webpack_public_path__ + "static/stardust-icon-space-340e3e075c4122dfc6697e3af6b4a2b9.png";